import React from 'react';
// import PropTypes from 'prop-types';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import ChangePasswordFormCard from '../components/ChangePasswordFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class ChangePasswordScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.PROFILE,
            Breadcrumbs.PROFILE_PASSWORD_EDIT,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_CAMBIAR_MI_CONTRASENA')} breadcrumbs={breadcrumbs}>
                <ChangePasswordFormCard/>
            </PsPage>
        );
    }

}

ChangePasswordScreen.propTypes = {};

ChangePasswordScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/profile/screens/ChangePasswordScreen.js